import { useSelector } from 'react-redux';
import ReactAudioPlayer from 'react-audio-player';
import { useTranslation } from 'react-i18next';
import {
    Description,
    Image,
    StyledPlayIcon,
    StyledStopIcon,
    StyledTask,
    Title,
    Button,
    ButtonsContainer,
    ImageContainer,
    Link,
    SecondDescription,
} from './styled';
import { selectTaskById } from '../../../../../Common/tasks/tasksSlice';
import { Line } from '../../Line';
import { useTaskActions } from './useTaskActions';
import { usePlayer } from '../../../../../Common/usePlayer';

const Task = ({ taskId }) => {
    const task = useSelector((state) => selectTaskById(state, taskId));
    const {
        translations, imgPath, board, id, audioPath, videoPath,
    } = task;
    const { isAudioOn, playerRef, onPlayerButtonClick } = usePlayer();
    const [onLoadSolution, onLoadTask] = useTaskActions(board, id);
    const { t, i18n } = useTranslation();
    const { language: currentLanguage } = i18n;
    const translation = translations.find(({ language }) => language === currentLanguage);

    return (
        <StyledTask>
            <Line />
            <Title>{translation?.title}</Title>
            <Description>{translation?.description}</Description>
            <ImageContainer>
                <Image src={`images/${imgPath}`} />
                <ButtonsContainer>
                    <Button type="button" onClick={onLoadTask}>
                        {t('Załaduj zadanie')}
                    </Button>
                    <Button type="button" onClick={onLoadSolution}>
                        {t('Załaduj rozwiązanie')}
                    </Button>
                    {audioPath && (
                        <Button type="button" onClick={onPlayerButtonClick}>
                            {isAudioOn ? t('Zatrzymaj piosenkę') : t('Posłuchaj piosenki')}
                            {isAudioOn ? <StyledStopIcon /> : <StyledPlayIcon />}
                        </Button>
                    )}
                    {videoPath && (
                        <Button as="a" href={videoPath} target="_blank" rel="noopener noreferrer">
                            {t('Zobacz karaoke')}
                        </Button>
                    )}
                    {audioPath && (
                        <ReactAudioPlayer
                            src={`${process.env.REACT_APP_CND_URL}/${audioPath}`}
                            ref={playerRef}
                            volume={0.5}
                            preload="none"
                        />
                    )}
                </ButtonsContainer>
            </ImageContainer>
            <SecondDescription>
                {t('Więcej zadań znajdziesz w książce')}
                <Link
                    href="https://edu-sense.com/pl/produkty/ksiazka-basnie-w-obrazkach-zakodowane-504"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {t('Baśnie w obrazkach zakodowane.')}
                </Link>
                .
            </SecondDescription>
        </StyledTask>
    );
};

export default Task;
